import { render, staticRenderFns } from "./parent-child-icon-grey.vue?vue&type=template&id=64a45410&functional=true"
import script from "./parent-child-icon-grey.vue?vue&type=script&lang=js"
export * from "./parent-child-icon-grey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports